var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Deep clones an array or object
 *
 * @template T
 * @param {T} data
 * @return {*}  {T}
 *
 * @example
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 * var copy = cloneDeep(objects);
 * console.log(copy[0] === objects[0]);
 * // returns false
 *
 */
export var cloneDeep = function (data) {
    if (typeof data === 'object' && data != null) {
        var clonedObj_1 = (Array.isArray(data) ? [] : {});
        Object.entries(data).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], entryData = _b[1];
            clonedObj_1[key] = cloneDeep(entryData);
        });
        return clonedObj_1;
    }
    return data;
};
//# sourceMappingURL=cloneDeep.js.map